const DEFAULT_API_BASE_URL = 'https://api.barnamegram.ir/api/';

type RuntimeConfig = {
  VITE_APP_BASE_URL?: string;
  VUE_APP_API_BASE_URL?: string;
};

const runtimeConfig: RuntimeConfig =
  typeof window !== 'undefined'
    ? window.__BARNAMEGRAM_CONFIG__ || window.__BARGRAM_CONFIG__ || {}
    : {};

/**
 * Runtime config is loaded from /runtime-config.js so the Docker image can be
 * configured when the container starts, without rebuilding the frontend.
 */
export const API_BASE_URL =
  runtimeConfig.VITE_APP_BASE_URL?.trim() ||
  runtimeConfig.VUE_APP_API_BASE_URL?.trim() ||
  import.meta.env.VITE_APP_BASE_URL?.trim() ||
  DEFAULT_API_BASE_URL;
